module.exports = "query Imports ($limit: Int = 100, $page: Int = 1, $company: String!) {\n  imports (limit: $limit, page: $page, company: $company) {\n    total\n    per_page\n    current_page\n    from\n    to\n\n    data {\n      user {\n        name\n      }\n      created_at\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Imports.graphql
// module id = Ox5E
// module chunks = 1624